import { SavingsView } from "../views/SavingsView";
import { DomainLayout } from "@/components/layouts/DomainLayout";

export const SavingsPage = () => {
    return (
        <DomainLayout>
            <SavingsView />
        </DomainLayout>
    )
}
